import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Text, Button } from '@chakra-ui/react';

const MenuButton = ({ children, label, isActive = false, ...rest }) => {
  return (
    <Button
      px={2.5}
      variant="ghost"
      height={'44px'}
      color={'#11284B'}
      fontSize={'16px'}
      _hover={{ bg: '#11284B', color: '#fff' }}
      _active={{ bg: '#11284B', color: '#fff' }}
      _focus={{ boxShadow: 'none ' }}
      borderRadius={0}
      isActive={isActive}
      {...rest}
    >
      {children && <Fragment>{children}</Fragment>}
      {label && <Text fontWeight={700}>{label}</Text>}
    </Button>
  );
};

MenuButton.propTypes = {
  label: PropTypes.string,
  isActive: PropTypes.bool,
  children: PropTypes.any,
};

export default MenuButton;



// WEBPACK FOOTER //
// src/components/layout/MenuButton/MenuButton.jsx